import { ChildrenProps, ClassNameProps, Column, Modal, ModalProps, Scaled, StyleProps } from "@hex-insights/core";

export type ScaledViewModalProps = Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function ScaledViewModal({ ifRef, onClose, className, style, children }: ScaledViewModalProps) {
	return (
		<Modal
			size="large"
			ifRef={ifRef}
			onClose={onClose}
			className={className}
			style={{ height: "fit-content", overflow: "hidden", ...style }}
		>
			<Modal.Body style={{ height: "100%" }}>
				<Column justify="center" style={{ height: "100%" }}>
					<Scaled className="nowrap" style={{ width: "100%", maxHeight: "100%" }}>
						{children}
					</Scaled>
				</Column>
			</Modal.Body>
		</Modal>
	);
}
